import gql from 'graphql-tag';

export const CompanyHubAnnouncementBannerStatusQuery = gql`
	query CompanyHubAnnouncementBannerStatusQuery($bannerId: String!) {
		adminAnnouncementBannerSetting(id: $bannerId) {
			id
			status
		}
	}
`;
